
import { DefaultState } from 'store/types';

export const MOVE_ROOM_REQUEST = 'MOVE_ROOM_REQUEST';
export const MOVE_ROOM_SUCCESS = 'MOVE_ROOM_SUCCESS';
export const MOVE_ROOM_FAILURE = 'MOVE_ROOM_FAILURE';

export interface MoveRoomParams {
  roomId: string;
  toLodgingId: string;
};

export interface MoveRoomData {
  
};

export type MoveRoomState = DefaultState & {
  contents?: MoveRoomData;
};

interface MoveRoomDataRequest {
  type: typeof MOVE_ROOM_REQUEST;
};

interface MoveRoomDataSuccess {
  type: typeof MOVE_ROOM_SUCCESS,
  contents: MoveRoomData;
}

interface MoveRoomDataFailure {
  type: typeof MOVE_ROOM_FAILURE;
}

export type MoveRoomActionTypes = MoveRoomDataRequest | MoveRoomDataSuccess | MoveRoomDataFailure;